import * as styledComponents from "styled-components";

import { ThemedStyledComponentsModule } from "styled-components";
import { IThemeInterface } from "~/styled/theme";

const {
  default: styled,
  css,
  injectGlobal,
  keyframes,
  ThemeProvider
} = styledComponents as ThemedStyledComponentsModule<IThemeInterface>;

export { IThemeInterface, theme } from "~/styled/theme";
export { css, injectGlobal, keyframes, ThemeProvider, styled as default };



// WEBPACK FOOTER //
// ./src/styled/index.ts